import styled from 'styled-components';

const StickyWrapper = styled.div`
  @media (min-width: 1025px) {
    display: none;
  }

  margin-top: 0;
  margin-bottom: 0;
  padding: 0px 0px;
  //will-change: transform;
  box-sizing: border-box;

  @media (orientation: portrait) {
    z-index: 11;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: var(--app-mobile-menu-total-height);

    padding: 3px 3px calc(3px + var(--app-safe-area-bottom));
    background-color: #131315;
  }
  @media (orientation: landscape) {
    position: relative;
    height: min(100dvh, 100%);
    flex: 0 0
      calc(var(--app-mobile-menu-landscape-width) + var(--app-safe-area-left));
    padding-left: var(--app-safe-area-left);

    background-color: transparent;

    //z-index: 10;
    //position: fixed;
    //right: 0;
    //top: 0;
    //bottom: 0;
    //width: 50px;
    //height: 100vh;
    //border-right: 1px solid #1b202d;
  }

  ${({ $flexMain }) =>
    $flexMain &&
    `
    position: relative;
    @media (orientation: portrait) {
        position: relative;
        height: var(--app-mobile-menu-total-height);
        flex: 0 0 var(--app-mobile-menu-total-height);
    }
    // @media (orientation: landscape) {
    //   position: relative;
    //   height: 100%;
    // }
  `};
`;

const ContentStyle = styled.div`
  bottom: 0;
  position: absolute;
  align-items: center;
  //  background-color: #27262b;

  @media (orientation: portrait) {
    width: 100%;
    height: var(--app-mobile-menu-total-height);
    padding: 3px 3px calc(3px + var(--app-safe-area-bottom));
    background-color: #131315;
  }
  @media (orientation: landscape) {
    width: calc(
      var(--app-mobile-menu-landscape-width) + var(--app-safe-area-left)
    );
    height: 100%;
    position: relative;
    padding-left: var(--app-safe-area-left);
    background-color: transparent;
  }
`;

const StyleInner = styled.div`
  position: absolute;

  @media (orientation: portrait) {
    width: 100%;
    /* height: 74px; */
    left: 0px;
    //top: 8px;
  }
  @media (orientation: landscape) {
    //width: auto;
    height: 100%;
    //left: 7px;
    //top: 0px;
  }
`;

const ContainerStyle = styled.div`
  width: 100%;
  justify-content: space-between;

  @media (orientation: portrait) {
    padding-left: 2px;
    padding-right: 2px;
    display: inline-flex;
    height: var(--app-mobile-menu-height);
  }
  @media (orientation: landscape) {
    display: flex;
    height: min(100dvh, 100%);
    flex-direction: column;
    padding: 4px;

    gap: 4px;
  }
`;

export { StickyWrapper, ContentStyle, StyleInner, ContainerStyle };

export const LandscapeOnly = styled.div`
  display: none;

  @media (orientation: landscape) {
    display: contents;
  }
`;
